import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-63b1629e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "virtual_contain"
};
const _hoisted_2 = {
  class: "virtual_head"
};
const _hoisted_3 = {
  class: "virtual_content"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "name"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "｜", -1));

const _hoisted_9 = {
  class: "more"
};
const _hoisted_10 = ["href"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowRight = _resolveComponent("ArrowRight");

  const _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.virtualList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "virtual_li",
      key: item.id
    }, [_createElementVNode("a", {
      href: `/virtualDetail.html?detailId=${item.id}&menuId=${$props.menu.menu_id}`
    }, [_createElementVNode("img", {
      src: item.cover_url,
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.master_name), 1), _hoisted_8, _createElementVNode("span", null, _toDisplayString(item.subject), 1)])], 8, _hoisted_4)]);
  }), 128))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("a", {
    href: `/virtual.html?name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, [_hoisted_11, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })], 8, _hoisted_10)])]);
}